var _linearGradient, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeTypeHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z",
    style: {
      fill: "#ebebeb",
      fillOpacity: 1
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 28.529,
    x2: 33.6,
    y1: -3905.471,
    y2: -3900.4,
    gradientTransform: "matrix(1 0 0 -1 0 -3890)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z",
    style: {
      fill: "#ccc",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ad3f16",
    d: "m22.165 46.827 11.39-12.656-1.414-1.414-12.656 11.39a1.897 1.897 0 1 0 2.68 2.68z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#751b0b",
    d: "m42.774 32.077-8.51-8.511-5.354 5.352 8.51 8.511z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6742d",
    d: "m36.032 36.021 5.355-5.355a.983.983 0 0 0 0-1.39l-4.31-4.309a.983.983 0 0 0-1.39 0l-5.354 5.355a.983.983 0 0 0 0 1.39l4.309 4.309a.983.983 0 0 0 1.39 0zm-7.102-7.125 5.332-5.331a.999.999 0 1 0-1.414-1.414l-5.331 5.331a1 1 0 0 0 1.414 1.414zm9.9 9.899 5.332-5.331a.999.999 0 1 0-1.414-1.414l-5.331 5.331a.999.999 0 1 0 1.414 1.414z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeTypeHold);
export default __webpack_public_path__ + "static/media/noticeTypeHold.d3ee5836ae6adf9dc058a5198f14df7b.svg";
export { ForwardRef as ReactComponent };